import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { BaseEntity, InlineContainerService, BaseInlineContainer, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-radno-mesto-poslovi-stavka-update-container',
  templateUrl: './radno-mesto-poslovi-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class RadnoMestoPosloviStavkaUpdateContainerComponent<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(
    inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService
  ) { 
    super(inlineContainerService, activatedRoute, userService)
  }

  tempItems: List<T>
  setItems(items){
    this.tempItems = items;
  }

}
